import { render, staticRenderFns } from "./configSettingModal.vue?vue&type=template&id=4c1072dd&scoped=true"
import script from "./configSettingModal.vue?vue&type=script&lang=js"
export * from "./configSettingModal.vue?vue&type=script&lang=js"
import style0 from "./configSettingModal.vue?vue&type=style&index=0&id=4c1072dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1072dd",
  null
  
)

export default component.exports